//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../common.module'
import { CommonHelper, FilterNames } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { i18n } from '../i18n/common.i18n'
import { GridSelectBridge } from './grid-select.directive'
import { GridOptions, GridTypes } from '../grid/grid.controller'
import { MapOptions, Map } from '../map2/map.directive.controller'
import { OpMarker } from '../../../models/custom/op-map-area'

import { MapHelper } from '../../../helpers/map-helper'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { IUserSession } from '../../../helpers/user-session'

import { OpBounds } from '../../../models/custom/op-map-area'
import { TemplateHelper, ConfigHelper, TypeHelper } from '../../../helpers'
import { IMRBaseControlDirectiveController } from '../base'


interface GridSelectScope extends ng.IScope {
    popoverOptions: DevExpress.ui.dxPopoverOptions
    popoverVisible: boolean
    popoverCloseOnOutsideClick: boolean
    togglePopover(): void
    popupVisible?: boolean
    toolbarOptions: DevExpress.ui.dxToolbarOptions
    tabsVisible: boolean
    tabSettings: any
    tabsIndex: number
    mapStyleWithFilterBox: any

    gridOptions: GridOptions
    columnsCount: number

    gridLoading: boolean

    textBoxOptions: DevExpress.ui.dxTextBoxOptions
    textBoxButtonOptions: DevExpress.ui.dxButtonOptions

    serialNumber: number
    bridge: GridSelectBridge

    mapOptions: MapOptions
}

export class GridSelectController extends IMRBaseControlDirectiveController {
    private grid: DevExpress.ui.dxDataGrid
    private isChangeMapStyle: boolean
    private mapDeferred = $.Deferred<Map>()

    constructor(
        protected $scope: GridSelectScope,
        protected $q: ng.IQService,
        protected $timeout: ng.ITimeoutService,
        protected api: Api,
        protected logger: LoggerService,
        protected $compile: ng.ICompileService,
        private localDictionary: LocalDictionaryFactory,
        private userSession: IUserSession
    ) {
        super()

        $scope.$watch("popupVisible", value => {
            if (value == false) {
                $scope.popoverVisible = false
            }
        })
        $scope.popoverVisible = false
        $scope.popoverCloseOnOutsideClick = true
        $scope.tabsVisible = false
        this.isChangeMapStyle = false

        $scope.popoverOptions = {
            width: 600,
            height: 500,
            target: '#popover_' + $scope.$id,
            bindingOptions: {
                visible: 'popoverVisible',
                closeOnOutsideClick: 'popoverCloseOnOutsideClick'
            },
            onHiding: () => {
                $scope.popoverVisible = false
            }
        }

        $scope.toolbarOptions = {
            items: [{
                location: 'after',
                widget: 'dxButton',
                options: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
                    onClick: () => {
                        this.grid.clearSelection()
                        $scope.togglePopover()
                    }
                }
            }, {
                location: 'after',
                widget: 'dxButton',
                options: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Apply),
                    onClick: (e: any) => {
                        const selectedData: any[] = this.grid.getSelectedRowsData()
                        if ($scope.bridge != null && selectedData != null && selectedData.length > 0) {
                            $scope.bridge.elements = selectedData

                            if (selectedData.length === 1 && TypeHelper.isFunction($scope.bridge.onSelected)) {
                                $scope.bridge.onSelected({ data: selectedData[0] })
                            }
                        }
                        $scope.togglePopover()
                    }
                }
            }]
        }

        $scope.togglePopover = () => {
            $scope.popoverVisible = !$scope.popoverVisible
        }
        $scope.gridLoading = true

        var getData = () => {
            const defer = this.$q.defer()

            const columnRequest = $scope.bridge.columnsDictionary
                ? this.$q.resolve($scope.bridge.columnsDictionary)
                : $scope.bridge.columnRequest()


            columnRequest.then(defaultColumns => {
                $scope.columnsCount = defaultColumns.length
                $scope.gridOptions = {
                    ignoreKey: true,
                    referenceId: $scope.bridge.gridReferenceId,
                    type: GridTypes.PAGINATED_SMALL,
                    name: $scope.bridge.name,
                    request: $scope.bridge.dataRequest,
                    dataSourceParser: $scope.bridge.dataSourceParser,
                    getDataSourceMethod: $scope.bridge.getAvailableDataSourceMethod,
                    buttonsOptions: {
                        enabled: true,
                        addPermissions: $scope.bridge.addPermissions,
                        onAddClick: () => { $scope.bridge.onAddClick(this.grid) }
                    },
                    columnsDictionary: defaultColumns,
                    columnAutoWidth: true,
                    allowColumnReordering: $scope.bridge.allowColumnReordering,
                    onSelectionChanged: e => {
                        $scope.bridge.onSelect(e)
                    },
                    selection: $scope.bridge.selection,
                    dataSource: $scope.bridge.data,
                    gridItemFilter: $scope.bridge.gridItemFilter,
                    onRowDoubleClick: e => {
                        $scope.bridge.onDoubleRowClick(e)
                        $scope.togglePopover()
                        this.grid.clearSelection()
                    },
                    onContentReady: () => {
                        $scope.gridLoading = false
                        const grid = this.grid
                        const dataSource = grid.option('dataSource')
                        var items: any[] = []
                        if (dataSource.items) items = dataSource.items()
                        else if (angular.isArray(items)) items = dataSource
                        let markers: OpMarker[] = []
                        items.forEach(item => {
                            let marker = CommonHelper.getMarkerFromData(item)
                            if (marker)
                                markers.push(marker)
                        })
                        this.mapDeferred.promise().then(map => {
                            map.setMarkers(markers)
                            $timeout(() => {
                                map.zoomCenter()
                            }, 100)
                        })
                        if (this.isChangeMapStyle) {
                            $scope.mapStyleWithFilterBox = {
                                "height": "78%"
                            }
                            this.isChangeMapStyle = false
                        }
                    },
                    onInitialized: (e) => {
                        this.grid = e.component
                        defer.resolve()
                    },
                    addCustomFilters: true,
                    needCustomFilter: true,
                    localStorageVarForSavedEntity: $scope.bridge.localStorageVarForSavedEntity
                }
            })

            return defer.promise
        }

        getData()

        if ($scope.bridge.name == 'routePointsGrid') {
            $scope.tabsVisible = true

            $scope.tabsIndex = 0
            $scope.tabSettings = {
                "dataSource": this.getTabs(),
                "selectedIndex": $scope.tabsIndex,
                "onItemClick": (e) => {
                    $scope.tabsIndex = e.itemIndex

                    if (e.itemIndex == 1) {
                        this.initializeMap()
                        this.centerMap()
                    }
                }
            }
        }

        $scope.$on(EventsNames.RESET_MAP_STYLE, (event, ...args) => {
            $scope.mapStyleWithFilterBox = {}
        })

        $scope.textBoxOptions = {
            width: '100%',
            placeholder: i18n('Common', 'Select...'),
            readOnly: true,
            bindingOptions: {
                value: 'bridge.value'
            },
            onFocusIn: () => {
                $scope.popoverVisible = true
            }
        }
        $scope.textBoxButtonOptions = {
            activeStateEnabled: false,
            template: TemplateHelper.getIcon(ConfigHelper.Icon.ARROW_DROP_UP, this.userSession),
            onClick: () => {
                $scope.togglePopover()
            }
        }

        $scope.$on(EventsNames.VALUE_FROM_GRID_SELECT_ADDED, () => {
            this.grid.clearSelection()
        })

        $scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, () => {
            $scope.togglePopover()
        })
    }

    getTabs() {
        var tabs = []
        tabs.push({ text: i18n('Common', 'CommonX'), icon: "edit", name: 'common' })
        tabs.push({ text: i18n('Common', 'Map'), icon: "map", name: 'map' })

        return tabs;
    }

    protected addCustomGridFilter(filter: any) {
        var self = this
        filter.clearFilter = () => {
            if (self.grid) {
                var filters: any = self.grid.filter()
                if (filters) {
                    filters = filters.filter(filter => {
                        return !filter.customgridfilter
                    })
                    if (filters.length > 0)
                        self.grid.filter(filter)
                    else
                        self.grid.filter(null)
                }
            }
        }
        filter.customgridfilter = true
        if (this.grid) {
            try {
                this.grid.clearFilter()
                this.grid.filter([filter])
            } catch (e) { }
        }
    }

    private initializeMap(): void {
        if (this.$scope.mapOptions == null) {
            MapHelper
                .getDefaultOptions(this.userSession.getDataProvider())
                .then((mapOptions: MapOptions) => {
                    mapOptions.onMapInit = (map: Map) => {
                        this.mapDeferred.resolve(map)
                    }

                    mapOptions.enableAreaSelect = true
                    mapOptions.hideCloseButton = true

                    mapOptions.onAreaSelect = (bounds: OpBounds) => {
                        MapHelper
                            .getCoordColumnNames(this.userSession.getDataProvider())
                            .then(([latColName, lonColName]: [string, string]) => {
                                this.addCustomGridFilter(CommonHelper.getLonLatFilter(bounds, latColName, lonColName, FilterNames.LocationsByMarkers))
                                this.isChangeMapStyle = true
                            })
                    }

                    mapOptions.onMapResize = (isMapFullScreen: boolean) => {
                        this.$scope.popoverCloseOnOutsideClick = !isMapFullScreen
                    }

                    this.$scope.mapOptions = mapOptions
                })
        }
    }

    private centerMap(): void {
        this.mapDeferred.then((map: Map) => {
            map.zoomCenter()
        })
    }
}